import { useState, useEffect } from "react"
import { MeetingServiceFilterProps } from "../components/FiltersDrawerMeetingService"
import { useAppSelector } from "../../../../../store/storeHooks"
import { selectEffectiveUserType } from "../../../../../context/contextSelectors"

type DisabledFilters = {
    disablePendingApproval?: boolean
    disableInvoicing?: boolean
    disableDeliveryDate?: boolean
    disableMerchantShops?: boolean
    disableServicePayment?: boolean
}

const useActiveFiltersCount = (filters: MeetingServiceFilterProps, disabledFilters?: DisabledFilters) => {
    const [activeCounts, setActiveCounts] = useState({
        orderActive: 0,
        invoiceActive: 0,
        bookedDateActive: 0,
        deliveryDateActive: 0,
        merchantActive: 0,
        debtorActive: 0,
        endUserActive: 0,
        paymentActive: 0,
    })

    const currentUserType = useAppSelector(selectEffectiveUserType)

    useEffect(() => {
        const countActiveFilters = (conditions: any[]) => conditions.filter(Boolean).length

        const orderActiveCount = disabledFilters?.disablePendingApproval
            ? countActiveFilters([filters.orderId])
            : countActiveFilters([filters.orderId, filters.pendingApproval])

        const invoiceActiveCount = disabledFilters?.disableInvoicing
            ? 0
            : countActiveFilters([
                  filters.invoiceStatus && filters.invoiceStatus !== "ALL",
                  filters.isBooked && filters.isBooked !== "ALL",
              ])

        const bookedDateActiveCount = countActiveFilters([filters.startBookedDate, filters.endBookedDate])

        const deliveryDateActiveCount = disabledFilters?.disableDeliveryDate
            ? 0
            : countActiveFilters([filters.startDeliveryDate, filters.endDeliveryDate])

        const merchantActiveCount = disabledFilters?.disableMerchantShops
            ? countActiveFilters([
                  filters.merchantIds && filters.merchantIds.length > 0,
                  filters.satelliteIds && filters.satelliteIds.length > 0,
              ])
            : countActiveFilters([
                  filters.merchantIds && filters.merchantIds.length > 0,
                  filters.shopIds && filters.shopIds.length > 0,
                  filters.satelliteIds && filters.satelliteIds.length > 0,
              ])

        const debtorActiveCount = countActiveFilters([
            filters.customerId,
            filters.buyerPartyIds && filters.buyerPartyIds.length > 0,
        ])
        const endUserActiveCount = countActiveFilters([filters.email, filters.employeeId])
        const paymentActiveCount = disabledFilters?.disableServicePayment
            ? 0
            : countActiveFilters([filters.paymentMethod && filters.paymentMethod.length > 0, filters.creditCardLast4])

        setActiveCounts({
            orderActive: orderActiveCount,
            invoiceActive: invoiceActiveCount,
            bookedDateActive: bookedDateActiveCount,
            deliveryDateActive: deliveryDateActiveCount,
            merchantActive: merchantActiveCount,
            debtorActive: debtorActiveCount,
            endUserActive: endUserActiveCount,
            paymentActive: paymentActiveCount,
        })
    }, [filters, currentUserType, disabledFilters])

    const totalActiveCount = Object.values(activeCounts).reduce((sum, count) => sum + count, 0)

    return {
        activeCount: totalActiveCount,
        ...activeCounts,
    }
}

export default useActiveFiltersCount

